import { Moment } from 'moment';

export default abstract class BaseType {
  abstract createdAt: Moment;

  abstract updatedAt: Moment;
}
